export default __webpack_public_path__ + "static/media/Indtech.03150c6f.png";